import validate from "/home/carlosdata/nuxtwp/nuxtwp/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_fa3271ce3153e0622da657dce3719d41/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/carlosdata/nuxtwp/nuxtwp/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_fa3271ce3153e0622da657dce3719d41/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}